
const { ccclass, property } = cc._decorator;
import ViewBase from "../../../table/module/poker_table/poker_table_seat_base_view"
import Utility from "../../../../utility/utility";
import GameUtil from "../../../../utility/game_util";
import {ColorSliderComponent} from "../../../texasholdem/module/table/component/colorslider_component"
import AudioManager from "../../../../manager/audio_manager";
import { Q2ColorSliderComponent } from "./com/q2_colorslider_component";

@ccclass
export default class Q2TableSeatView extends ViewBase {

    
    @property(cc.Node)
    nodeIntrusting: cc.Node = null
    
    @property(cc.Node)
    nodeRecharge: cc.Node = null

    @property(cc.Node)
    nodeBubble: cc.Node = null

    @property(cc.Label)
    labelBubble: cc.Label = null

    @property(cc.Node)
    nodeGoldParent: cc.Node = null

    @property(cc.Float)
    maxGoldPosRadius: number = 0
    
    @property(cc.Node)
    nodeWinEffect: cc.Node = null

    @property(cc.Node)
    nodePiaoFenAnim: cc.Node = null

    @property(cc.Label)
    labelWinPiaoFen: cc.Label = null

    @property(cc.Label)
    labelLosePiaoFen: cc.Label = null

    @property(cc.Node)
    nodeGoldAnim: cc.Node = null

    @property(cc.Node)
    nodeBankerAnim: cc.Node = null

    @property([cc.Node])
    nodeBgList: cc.Node[] = []

    @property(cc.Node)
    nodeWatch: cc.Node = null

    @property(Q2ColorSliderComponent)
    sliderClock: Q2ColorSliderComponent = null


    reset(){
        super.reset()

    }

    getSeatStyleName(index: number):string{
        switch (index) {
            case 0:
                return 'Bottom'
            case 1:
            case 2:
                return 'Left'
            case 3:
            case 4:
                return 'Right'
        
            default:
                break;
        }
        return ''
    }

    resetSeatStyle(index: number){
        this.setSeatBg(index)
    }

    
    showIntrustedTag(show: boolean){
        this.nodeIntrusting.active = show
    }

    showRechargeTag(show: boolean){
        this.nodeRecharge.active = show
    }

    showBubble(show: boolean, text?: string){
        this.nodeBubble.active = show
        if(show){
            this.labelBubble.string = text
        }        
    }


    showWinEffect(show: boolean, onFinish?: Function){
        this.nodeWinEffect.active = !!show
        this.scheduleOnce(function(){
            onFinish && onFinish()
        }, 0.8)
    }

    showPiaoFenAnim(show: boolean, score?: number, onFinish?: Function, clipIndex?: number){
        if(show){
            this.playPiaoFenAnim2(score, onFinish, clipIndex)
        }
    }


    protected playPiaoFenAnim2(score?: number, onFinish?: Function, clipIndex?: number){
        let node = cc.instantiate(this.nodePiaoFenAnim)
        node.active = true
        node.parent = this.nodePiaoFenAnim.parent
        node.position = this.nodePiaoFenAnim.position
        let anim = node.getComponent(cc.Animation)
        let clips = anim.getClips()
        clipIndex = clipIndex || 0
        anim.play(clips[clipIndex].name)
        let text = (score >= 0 ? '+': '') + score
        let label: cc.Label
        if(score >= 0){
            label = Utility.findChildNode(node, 'control/winScore').getComponent(cc.Label)
        }else{
            label = Utility.findChildNode(node, 'control/loseScore').getComponent(cc.Label)
        }
        label.node.active = true
        label.string = text
        this.scheduleOnce(function(){
            node.destroy()
            onFinish && onFinish()
        }, clipIndex == 0? 1.5: 0.95)
    }

    protected setSeatBg(index: number){
        for (let i = 0; i < this.nodeBgList.length; i++) {
            const node = this.nodeBgList[i];            
            node.active = index == i
        }
    }

    showClock(show: boolean, secs?: number, needShake?: boolean, onFinish?: Function, onTick?: Function, totalSecs?: number){
        super.showClock(show, secs, needShake, onFinish, onTick)
        this.sliderClock.node.active = !!show
        if(show){
            this.sliderClock.setOpTime(secs, totalSecs)
        }
    }

    showGoldAnim(show: boolean, delay?: number, onFinish?: Function){
        let self = this        
        if(show){
            let deal_fun = function(){
                let node = cc.instantiate(self.nodeGoldAnim)
                node.parent = self.nodeGoldAnim.parent
                node.position = self.nodeGoldAnim.position
                node.active = true
                self.scheduleOnce(function(){
                    node.active = false
                    node.destroy()
                    onFinish && onFinish()
                }, 1)
            }
            if(delay){
                self.scheduleOnce(function(){
                    deal_fun()
                }, delay)
            }else{
                deal_fun()
            }
        }
    }

    showBankerTag(show: boolean){
        super.showBankerTag(show)
        if(!show){
            this.nodeBankerAnim.active = false
        }
    }

    playSetBankerAnim(onFinish?: Function){
        let self = this        
        super.showBankerTag(false)
        this.nodeBankerAnim.active = true
        self.scheduleOnce(function(){
            self.nodeBankerAnim.active = false
            self.showBankerTag(true)
            onFinish && onFinish()
        }, 0.5)
    }

    setClickNotSeatBtnListener(callback: Function){
    }


    showWatchTag(show: boolean){
        this.nodeWatch.active = !!show
    }
}
